import { InjectionToken } from '@angular/core';
import { AuthOktaConfig } from '../../types/auth-okta-config';

export const AUTH_OKTA_MODULE_CONFIG = new InjectionToken<AuthOktaConfig>(
  'AUTH_OKTA_MODULE_CONFIG'
);
